import React, { FC, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { Tooltip } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUINoRecordComponent } from '../../atomic/atoms';
import cachePaymentImage from '../../assets/icons/svg/pageIcons/cashPayment.svg';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { PaymentQuery } from '../../services/query';
import { SCUIBreadCrumb, SCUITextFieldWithSelectBox } from '../../atomic/molecules';
import { Box, LinearProgress, Fade } from '@mui/material';
import { RPN } from './refundProcessNo.classes';

export const RefundProcessNo: FC<any> = () => {
    const { t } = useTranslation();
    const [documentType, setDocumentType] = React.useState(1);
    const [searchedText, setSearchedText] = useState('');

    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'Id', flex: 1, hide: true },
        { field: 'orderNumber', headerName: t('general.orderNo'), flex: 1 },
        {
            field: 'processDescription',
            headerName: t('general.processDescription'),
            flex: 1,
            headerAlign: 'center',
            align: 'left',
            renderCell: (params: any) => {
                return (
                    <div className={RPN.cellProcessDescription}>
                        <Tooltip title={params.row.processDescription}>
                            <p>{params.row.processDescription}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'processNo', headerName: t('general.processNo'), flex: 1 },
        { field: 'status', headerName: t('general.status'), flex: 1 },
    ];
    const [datas, setDatas] = React.useState<any>();
    const [barDisplay, setBarDisplay] = useState(false);
    const GetRefundProcessNoByOrderNo = async (): Promise<any> => {
        try {
            PaymentQuery.GetKKIadePortalData(searchedText).then((res: any) => {
                if (res.model.kkIadePortalData) {
                    let parseDataOrderNumber = res.model.kkIadePortalData.map((item: any) => {
                        return {
                            orderNumber: item.orderNumber || '-',
                            processNo: item.processNo || '-',
                            processDescription: item.processDescription || '-',
                            status: item.status || '-',
                        };
                    });
                    setDatas(parseDataOrderNumber);
                    setBarDisplay(false);
                } else {
                    Swal.fire(t('general.notFound'), ' ', 'error');
                    setBarDisplay(false);
                }
            });
        } catch (error) {
            setBarDisplay(false);
            console.log('Hata :>> ', error);
        }
    };

    return (
        <SCUIContent className={RPN.page}>
            <div className={RPN.breadcrumbSection}>
                <SCUIBreadCrumb title={t('general.refundProcessNo')} componentLink={'RefundProcessNo'} />
            </div>
            <div className={RPN.searchSection}>
                <SCUITextFieldWithSelectBox
                    className={RPN.searchPaper}
                    selectClassName={RPN.searchSelect}
                    inputClassName={RPN.searchInput}
                    iconButtonClassName={RPN.searchButton}
                    placeholder={' '}
                    selectList={[{ value: 1, text: t('general.orderNo') }]}
                    onChangeSelect={(event: any) => {
                        setDocumentType(event.target.value as number);
                    }}
                    selectValue={documentType}
                    onChangeTextField={(event: any) => {
                        setSearchedText(event.target.value);
                    }}
                    onClickButton={() => GetRefundProcessNoByOrderNo()}
                    onKeyPressTextField={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            GetRefundProcessNoByOrderNo();
                        }
                    }}
                />
            </div>

            <Box className={RPN.progressSection} sx={{ width: '100%' }}>
                <Fade in={barDisplay} unmountOnExit>
                    <LinearProgress className={RPN.progressBar} />
                </Fade>
            </Box>
            <div className={RPN.gridSection}>
                {datas ? (
                    <div className={RPN.dataGridWrap}>
                        <SCUICustomDataGrid rows={datas} columns={columns} randomId />
                    </div>
                ) : (
                    <div className={RPN.noRecordWrap}>
                        <SCUINoRecordComponent img={cachePaymentImage} />
                    </div>
                )}
            </div>
        </SCUIContent>
    );
};
